import { TextboxComponent } from './components/basic/textbox/textbox.component';
import { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Textbox = [
  TextboxComponent,
  DecoratorDirective
];
